module.exports = __webpack_public_path__ + "img/catalog-yaowarat.6e1fb667.jpg";